import { TWithdrawalStatus } from '../../store/types';

export const withdrawalStatusList: TWithdrawalStatus[] = [
  'created',
  'approved',
  'declined',
  'cancelled',
  'in_progress',
];

export const withdrawalStatusTitle: Record<TWithdrawalStatus, string> = {
  created: 'Создан',
  approved: 'Подтверждён',
  declined: 'Отклонён',
  cancelled: 'Отменён',
  in_progress: 'В работе',
};
